import React, { memo } from 'react';

import {
    StyledOuterWrapper,
    StyledErrorContent,
    StyledBar,
    StyledErrorTitle,
    StyledErrorMessage,
    StyledErrorIcon,
} from 'adapter/in/common/components/widgets/Error/style';

type ErrorWidgetProps = {
    width: number;
    height: number;
    errorMessage: string;
    errorTitle: string;
    icon: string;
};

const getSize = (width: number, height: number) => {
    const iconRelation = 4;
    const fontSizeRelation = 20;

    const applyCorrection = (property: number, unlimited: boolean) => {
        const proportion = height / width;
        const basicSize = width / property;

        return unlimited ? basicSize * Math.min(proportion) : basicSize * Math.min(proportion, 0.8);
    };

    const iconSize = applyCorrection(iconRelation, true);
    const fontSize = applyCorrection(fontSizeRelation, false);

    return { iconSize, fontSize };
};

const ErrorWidget = (props: ErrorWidgetProps): JSX.Element => {
    const { errorMessage, width, height, errorTitle, icon } = props;

    const { iconSize, fontSize } = getSize(width, height);

    return (
        <StyledOuterWrapper data-testid='error-widget' fontSize={fontSize}>
            <StyledBar data-testid='color-check' />
            <StyledErrorContent>
                <StyledErrorIcon size={iconSize} name={icon} />
                <StyledErrorTitle>{errorTitle}</StyledErrorTitle>
                <StyledErrorMessage>{errorMessage}</StyledErrorMessage>
            </StyledErrorContent>
        </StyledOuterWrapper>
    );
};

export default memo(ErrorWidget);
